// extracted by mini-css-extract-plugin
module.exports = {"button":"RemoveButton_button__TgfMd"};